import { apiClient } from './client'

export interface PartCatalogEntry {
  id: string
  partNumber: string
  brand: string
  createdAt: string
}

export async function getPartCatalog(
  q?: string,
  limit = 500,
): Promise<{ items: PartCatalogEntry[]; total: number }> {
  const res = await apiClient.get<{ success: true; data: PartCatalogEntry[]; total: number }>(
    '/part-catalog',
    { params: { ...(q ? { q } : {}), limit } },
  )
  return { items: res.data.data, total: res.data.total }
}

// Автоподсказка partNumber по префиксу. Возвращает пары {partNumber, brand}
// — бренд используется для заполнения соседнего поля при выборе подсказки.
// signal — опциональный AbortSignal, чтобы вызывающий мог отменять предыдущий
// запрос при новом keystroke (см. ItemsTable). Это режет лишний трафик в БД
// part_catalog и снимает нагрузку с rate-limit при быстром наборе.
export async function suggestPartNumbers(
  q: string,
  limit = 10,
  signal?: AbortSignal,
): Promise<Array<{ partNumber: string; brand: string }>> {
  if (q.trim().length < 2) return []
  const res = await apiClient.get<{
    success: true
    data: Array<{ partNumber: string; brand: string }>
  }>('/part-catalog/suggest', { params: { q, limit }, signal })
  return res.data.data
}

export async function lookupBrand(partNumber: string): Promise<string | null> {
  const res = await apiClient.get<{ success: true; data: { brand: string | null } }>(
    '/part-catalog/lookup',
    { params: { partNumber } },
  )
  return res.data.data.brand
}

export interface ImportCatalogResult {
  inserted: number
  updated: number
  skipped: number
  errors: number
  total: number
}

export async function importPartCatalog(
  rows: Array<{ partNumber: string; brand: string }>,
): Promise<ImportCatalogResult> {
  const res = await apiClient.post<{ success: true; data: ImportCatalogResult }>(
    '/part-catalog/import',
    { rows },
  )
  return res.data.data
}
